import apiClientService from "./ApiClientService";

// Sectoarele școlii: [{ id, name, hasPolygon, isActive, sortOrder }]
// (și cele dezactivate). Adăugarea și schimbarea — doar adminul.

async function readOrThrow(res, fallback) {
   if (res.ok) return res.json();
   let msg = fallback;
   try {
      const err = await res.json();
      if (err?.message) msg = Array.isArray(err.message) ? err.message.join(" ") : err.message;
   } catch {}
   throw new Error(msg);
}

export async function getDistricts() {
   return readOrThrow(
      await apiClientService.get("/districts"),
      "Nu am putut încărca sectoarele.",
   );
}

export async function createDistrict({ name, hasPolygon = false }) {
   return readOrThrow(
      await apiClientService.post("/districts", { name, hasPolygon: Boolean(hasPolygon) }),
      "Nu am putut adăuga sectorul.",
   );
}

/** patch: { hasPolygon?, isActive?, sortOrder? } — numele nu se schimbă. */
export async function updateDistrict(id, patch) {
   return readOrThrow(
      await apiClientService.patch(`/districts/${Number(id)}`, patch),
      "Nu am putut salva sectorul.",
   );
}
